export default __webpack_public_path__ + "static/media/CHLA_myCHLA User Guide_Practice Owner Account Management Process.d9ceda5e.pdf";